var React = require('react');

function Marker (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2.01c-3.856 0-6.992 3.138-6.992 6.994 0 4.483 5.967 11.765 6.221 12.072l.771.936.771-.936c.254-.308 6.221-7.589 6.221-12.072 0-3.857-3.136-6.994-6.992-6.994zm0 2a5 5 0 0 1 4.992 4.994c0 2.705-3.114 7.357-4.992 9.822-1.878-2.463-4.992-7.113-4.992-9.822A5 5 0 0 1 12 4.01zm0 2.49a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5z"}));
}

Marker.defaultProps = {"viewBox":"0 0 24 24","fill":"#faffff","xmlnsV":"https://vecta.io/nano"};

module.exports = Marker;

Marker.default = Marker;
